import React, { useState, useEffect } from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

function PageControl(props) {
  let control;
  // useEffect(() => {
    
  // }, [props.allowNext]);
  switch (props.page) {
    // case 0:
    //   control = (
    //     <div className="side-panel-actions">
    //       <Col>
    //         <Button variant="primary" disabled>
    //           Vorige
    //       </Button>
    //         <Button variant="primary" onClick={props.nextPage} disabled={props.canNext}>
    //           Volgende
    //       </Button>
    //       </Col>
    //     </div>
    //   );
    //   break;
    case 6://6:
      control = (
        <div className="side-panel-actions">
          <Col>

            <Button variant="primary" onClick={props.prevPage}>
              Vorige
          </Button>
            <Button variant="primary" onClick={() => props.handleOrderPopup(true)} disabled={!props.allowNext}>
              Bestellen
          </Button>
          </Col>
        </div>
      );
      break;
    default:
      control = (
        <div className="side-panel-actions">
          <Col>
            <Button variant="primary" onClick={props.prevPage}>
              Vorige
          </Button>
            <Button variant="primary" onClick={props.nextPage} disabled={!props.allowNext}>
              Volgende
          </Button>
          </Col>
        </div>
      );
  }

  return control;
}

export default PageControl;
